module.exports = __webpack_public_path__ + "static/media/movie-app-thumb.e536b1e5.PNG";